import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import { AutocompleteDTO } from 'src/app/models/types/ProductsSearch/AutocompleteDTO.type copy';
import { SearchDTO } from 'src/app/models/types/ProductsSearch/SearchDTO.type';

@Injectable({
  providedIn: 'root'
})
export class ProductsSearchService {

  private readonly apiUrl = `${environment.productSearchBaseUrl}`;
  private readonly apiKey = `${environment.productSearchApiKey}`;

  private readonly searchEndpoint = "search?api-version=2020-06-30"
  private readonly autocompleteEndpoint = "autocomplete?api-version=2020-06-30"

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  /**
     * API
     * @param searchText -  Testo da cercare
     */
  autocomplete(searchText: string): Observable<AutocompleteDTO> {
    const url = `${this.apiUrl}/${this.autocompleteEndpoint}`;
    const autocompleteMode = searchText.trim().split(/\s+/).length > 1 ? 'twoTerms' : 'oneTerm';

    const payload = {
      search: searchText.trim(),
      searchFields: '',
      suggesterName: 'products-suggester',
      autocompleteMode: autocompleteMode,
      top: 1
    };

    const headers = new HttpHeaders({ 'api-key': this.apiKey });
    return (this.http.post(url, payload, { headers }) as Observable<AutocompleteDTO>);
  }

  searchProduct(searchText: string, skip: number = 0): Observable<SearchDTO> {
    const url = `${this.apiUrl}/${this.searchEndpoint}`;

    const payload = {
      search: searchText.trim(),
      scoringProfile: 'score-category',
      searchFields: 'SAPCode, CatalogCode, LongDescription_en_US, AccessoriesShape_en_US, AestheticLine_en_US, MainStone_en_US, MainColor_en_US, Metal_en_US, WatchBandMaterial_en_US, WatchCaseMaterial_en_US, Tags',
      select: 'SAPCode, CatalogCode, LongDescription_en_US, AccessoriesShape_en_US, AestheticLine_en_US, MainStone_en_US, MainColor_en_US, Media, IsNewIn, CanShowPrice, LowPriorityJewelry, Classification',
      count: true,
      skip: skip,
      searchMode: 'all'
    };

    const headers = new HttpHeaders({ 'api-key': this.apiKey });
    return (this.http.post(url, payload, { headers }) as Observable<SearchDTO>);
  }
}
